import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { OptionTypeBase, ValueType } from 'react-select';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { assignGroupsWorkspaces } from '../../../stores/groups/actionCreators';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { workspaceOptions } from '../../../stores/workspaces/selectors';
import ConfirmModal from '../../common/modals/ConfirmModal';
import MultiSelect from '../../common/MultiSelect';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];
    workspaces: Array<{ label: string, value: string }>;

    assignGroupsWorkspaces: (groupIds: string[], workspaceIds: string[]) => void;
}

interface State {
    showModal: boolean;
    selection?: ValueType<{ label: string, value: string }> | null;
}

class AssignGroupsWorkspaceAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            selection: [],
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['ASSIGN_GROUP_WORKSPACE', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="no-icon"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        {t('groups.button.assignWorkspace')}
                    </DropdownItem>
                    <ConfirmModal
                        className="overflow-visible"
                        header={t('groups.modal.assignWorkspace.header') as string}
                        confirmText={t('modal.assign') as string}
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.assign();
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        <p>{t('groups.modal.assignWorkspace.text') as string}</p>
                        <Select className={"dropdown-select workspace-select"}
                            isMulti={true}
                            options={this.props.workspaces}
                            value={this.state.selection}
                            onChange={this.handleSelectChange}
                        />
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        this.setState({ selection: (val === null || val === undefined) ? [] : val });
    }

    private assign = () => {
        if (this.state.selection && Array.isArray(this.state.selection) && this.state.selection.length > 0) {
            this.props.assignGroupsWorkspaces(
                this.props.selected,
                this.state.selection.map((option) => option.value)
            );
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'groups'),
    workspaces: workspaceOptions(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    assignGroupsWorkspaces: (groupIds: string[], workspaceIds: string[]) =>
        dispatch(assignGroupsWorkspaces(groupIds, workspaceIds)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(AssignGroupsWorkspaceAction));